import { Box, Checkbox, Flex } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { ModuleId, ModuleName } from 'src/graphql/mappers/module';
export interface SingleModule {
    id: ModuleId;
    name: ModuleName;
    isModuleAssignedToUser: boolean;
    isDisabled: boolean;
    moduleInfo: string;
    hasAdditionalSettings: boolean;
}
export interface ModuleSelectorProps {
    singleModule: SingleModule;
    onSelectModule: (value: ModuleId) => void;
};

const ModuleSelector: FunctionComponent<ModuleSelectorProps> = ({ singleModule, onSelectModule }) => {
    return (
        <Flex flexDirection='column' key={singleModule.id}>
            <Checkbox
                key={singleModule.id}
                id={singleModule.name}
                label={singleModule.name}
                value={singleModule.id}
                defaultChecked={singleModule.isModuleAssignedToUser}
                isDisabled={singleModule.isDisabled}
                onChange={(ev: any) => {
                    if (singleModule.isDisabled) return;
                    onSelectModule(ev.target.value);
                }}
            />
            <Box
                pl='24px'
                className='px10_400_weak'
                aria-label={`additional module info for ${singleModule.name}`}
            >
                {singleModule.moduleInfo}
            </Box>
        </Flex>
    );
};

export default ModuleSelector;